import styled from 'styled-components'
 
/*
 grid-template-areas:
    "22           22           label-top    2e2         2e2"
    "1            tl           axis-top     tr          33"
    "label-left   axis-left    center       spr axis-right  label-right"
    "4            bl           axis-bottom  br          3"
    "44           44           label-bottom 4e4         4e4"
  ;
  */
const grid_areas = `
  grid-template-areas:
    "22           22           label-top    2e2         2e2"
    "1            tl           axis-top     tr          33"
    "label-left   axis-left    center       axis-right  label-right"
    "4            bl           axis-bottom  br          3"
    "44           44           label-bottom 4e4         4e4"
  ;

  [data-area='tl'] { grid-area: tl; }
  [data-area='tr'] { grid-area: tr; }
  [data-area='bl'] { grid-area: bl; }
  [data-area='br'] { grid-area: br; }

  [data-area='label-left'] { grid-area: label-left; }
  [data-area='label-right'] { grid-area: label-right; }
  [data-area='label-top'] { grid-area: label-top; }
  [data-area='label-bottom'] { grid-area: label-bottom; }

  [data-area='center'] { grid-area: center; }
  [data-area='chart'] { grid-area: chart; }

  [data-area='axis-top'] { grid-area: axis-top; }
  [data-area='axis-bottom'] { grid-area: axis-bottom; }
  [data-area='axis-left'] { grid-area: axis-left; }
  [data-area='axis-right']  { grid-area: axis-right; }

  [data-area='scroll-area'],
  [data-area='inner-grid'] {
    grid-row: 2 / span 3;
    grid-column: 2 / span 3;
    background: white;
  }

  [data-inner='true'] {
    position: absolute;
  }
 

  
`

export const FixedTooltipContainer = styled.div`
  position: fixed;
`

const axis_styles = `

  .axis {
 
    position: relative;
     
    font-size: .9em;
     

    &[data-axis='left'],
    &[data-axis='right'] {
      bottom: -1px;
    }
    &[data-axis='top'],
    &[data-axis='bottom'] {
      display: flex;
      flex-direction: row;
    }
  }

  .tick {
    display: grid;
     
    font-size: .9em;


    .inner {
      left: 0;
      top: 0;
      padding:  .5em;

      width: max-content;
      height: max-content;
    }
  }

  .tick--bottom,
  .tick--top {
    .inner { transform: translateX(-50%); }
  }
  
  .tick--left .inner { justify-self: end; }
  .tick--left,
  .tick--right {
 
    .inner {
      padding: .25em 1em .25em .25em;
      transform: translateY(-50%); 
    }
  }

  [data-axis][data-id='label'] {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: .5em;
    &[data-axis='left'] .inner { writing-mode: vertical-rl; transform: rotate(180deg); }
    &[data-axis='right'] .inner { writing-mode: vertical-lr; }
    &[data-axis='bottom'] { padding-top: .75em; }
    &[data-axis='right'] { padding-left: .75em; }
  }


  .has-overlapping-labels {
    .tick--bottom {
      transform: rotate(-90deg);
      transform-origin: left top;
      .inner {
        transform: translate(-100%, -50%);
        padding: .25em .5em;
        left: 0;
        top: 0;
      }
    }
  }
`
 
export const ConfigurableChartSizer = styled.div`

  font-size: 1em;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  box-sizing: content-box;
  display: grid;
  grid-template-columns: auto auto 1fr auto auto;
  grid-template-rows: auto auto 1fr auto auto;
  background-color: brown;
  ${grid_areas};
`
 
export const ConfigurableChartContainer = styled.div`
  font-size: 1em;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  box-sizing: content-box;
  display: grid;
  grid-template-columns: auto auto 1fr auto auto;
  grid-template-rows: auto auto 1fr auto auto;
  background-color: white;

  ${grid_areas};
  ${axis_styles};
  
  
  .scroll-shader {
  position: relative;
    &[data-axis='left'] {
   
    background: linear-gradient(to right, rgba(255,255,255,1) 75%, rgba(255,255,255,0) 100%);
    grid-column: axis-left;
    }
    &[data-axis='right'] {
      background: linear-gradient(to left, rgba(255,255,255,1) 90%, rgba(255,255,255,0) 100%);
      grid-column: axis-right;
    }
    
    &[data-axis='left'],
    &[data-axis='right'] {
      grid-row: axis-top / axis-bottom;
      bottom: 2px;

    }
  }

  .center-sizer {
 
    min-width: 150px;
    min-height: 150px;
  }

  .min-max {
    min-width: 800px;
    min-height: 150px;
  }

  opacity: 0;
  visibility: hidden;
  overflow: hidden;
  
   &[data-init='false'] {
   
  }
 
  &[data-init='true'][data-sized='true'] {
    visibility: visible;
    overflow: visible;
    opacity: 1;
  }

  &[data-sized='true'] {
    opacity: 1;

    .tick--left, .tick--right  { width: 100%; }
  }
  .bar-group { transform: translateX(-50%); }

  .grid {
    display: grid;
  }

 

  

  &[data-sized='false'] {
    opacity: 0;
  }

  &[data-sizing='true'] {
    overflow: hidden; 
  }

  &[data-sized='true'] {
    opacity: 1;
  }

  

  .grid-lines {
    position: relative;
 
  }
  .grid-line {
    position: absolute;
    background: rgba(0, 0, 0, 0.2);
   }
  .grid-line--horizontal { 
    width: 100%; 
    height: .5px;
 
    transform: translateY(-50%);
   }
  .grid-line--vertical { height: 100%; width: .5px; 
 
    transform: translateX(-50%);
  
   }

  

  .inner-grid {
    display: grid;
    grid-template-areas:
      "tl          axis-top     tr"
      "axis-left   center       axis-right"
      "bl          axis-bottom  br"
    ;
  }

  .tooltip-area,
  .chart-area {
    position: relative;
 
 
  }
 
  [data-id="scroll-area"] {
    grid-row: 2 / span 3;
    grid-column: 2 / span 3;
    grid-template-columns: inherit;
    grid-template-rows: inherit;
    position: absolute;
    overflow-x: auto;
    overflow-y: hidden;
    left: 0;
    top: 0;
    width: calc(100% + 5px);
    height: calc(100% + 5px);
  }
 
  [data-id='scroll-area-inner'] {
    grid-row: 1 / span 3;
    grid-column: 1 / span 3;
    position: relative;
    display: grid;
    grid-template-rows: inherit;
    grid-template-columns: inherit;
    
  }

  [data-axis][data-id='label'] {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: .5em;
    &[data-axis='left'] .inner { writing-mode: vertical-rl; transform: rotate(180deg); }
    &[data-axis='right'] .inner { writing-mode: vertical-lr; }
    &[data-axis='bottom'] { padding-top: .75em;}
    &[data-axis='right'] { padding-left: .75em;}
  }

 

  .scroll-area {
    .tooltip { display: none; }
  }
  
  &.configurable-pie-chart {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'center';
    visibility: visible;
    opacity: 1;
  }
`
 
export const AxisWrapperContainer = styled.div`
  display: grid;
  gap: .5em;
`

export const Sizer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  max-width: 100%;
  max-height: 100%;
`